import { render, staticRenderFns } from "./DiagAnswerItemInput.vue?vue&type=template&id=591b2f30&scoped=true&"
import script from "./DiagAnswerItemInput.vue?vue&type=script&lang=js&"
export * from "./DiagAnswerItemInput.vue?vue&type=script&lang=js&"
import style0 from "./DiagAnswerItemInput.vue?vue&type=style&index=0&id=591b2f30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591b2f30",
  null
  
)

export default component.exports